var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.bundleWarning
      ? _c("div", { staticClass: "bundle-policy-bound-alert p-3" }, [
          _c(
            "div",
            {
              staticClass:
                "row align-items-center justify-content-center no-gutters"
            },
            [
              _c("div", { staticClass: "col-7 col-max-width" }, [
                _c(
                  "div",
                  {
                    staticClass: "p-0 rounded-0 text-left alert alert-warning",
                    attrs: { role: "alert", "aria-atomic": "true" }
                  },
                  [
                    _c("p", [
                      _c("strong", [_vm._v("Policy Bound:")]),
                      _vm._v(" " + _vm._s(_vm.bindmsg))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 ml-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.navigateTo($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.submitButtonLabel))]
                )
              ])
            ]
          )
        ])
      : Array.isArray(_vm.formMessages)
      ? _c(
          "div",
          _vm._l(_vm.formMessages, function(formMessage, i) {
            return _c("div", {
              key: i,
              class: {
                "py-3 rounded-0": _vm.isPolicyAlert,
                "text-center": _vm.isPolicyAlert,
                "alert alert-warning": formMessage.type === "warning",
                "alert alert-danger": formMessage.type !== "warning"
              },
              attrs: { role: "alert", "aria-atomic": "true" },
              domProps: { innerHTML: _vm._s(formMessage.message) }
            })
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-533e0909", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533e0909","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/alerts/FormAlerts.vue
// module id = null
// module chunks = 